"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INACTIVITY_TIMEOUT_MS = exports.EXP_TIME_BUFFER_MS = exports.MID_REFRESH_TOKEN_KEY = exports.MID_CODE_VERIFIER = exports.MID_AUTH_EXPIRATION_TIME = exports.MID_REFRESH_MESSAGE_NAME = exports.MID_NONCE = exports.MID_USER_INFO_KEY = exports.MID_LOGIN_KEY = exports.MID_TENANT_KEY = exports.MID_ID_TOKEN_KEY = exports.MID_ACCESS_TOKEN_KEY = void 0;
// McKinsey ID Storage Constants
exports.MID_ACCESS_TOKEN_KEY = '_mid-access-token';
exports.MID_ID_TOKEN_KEY = '_mid-id-token';
exports.MID_TENANT_KEY = '_mid-tenant';
exports.MID_LOGIN_KEY = '_mid-login';
exports.MID_USER_INFO_KEY = '_mid-user-info';
exports.MID_NONCE = '_mid-nonce';
exports.MID_REFRESH_MESSAGE_NAME = '_mid-refresh-message';
exports.MID_AUTH_EXPIRATION_TIME = '_mid-exp';
exports.MID_CODE_VERIFIER = '_mid-code-verifier';
exports.MID_REFRESH_TOKEN_KEY = '_mid-refresh-token';
// 30 seconds to start going to get another token
exports.EXP_TIME_BUFFER_MS = 30 * 1000;
// 30 minute timeout
exports.INACTIVITY_TIMEOUT_MS = 30 * 60 * 1000;
